import React from 'react'
import styles from '../sass/whatsappButton.module.scss'

const WhatsAppButton = () => {
  const phoneNumber = '917093134343'
  const message = encodeURIComponent('Hello, I need assistance with dental products.')
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.whatsappButton}
      aria-label="Chat on WhatsApp"
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 0C7.164 0 0 7.164 0 16C0 18.777 0.735 21.377 2.012 23.623L0.692 31.308L8.607 30.012C10.777 31.165 13.303 31.823 16 31.823C24.836 31.823 32 24.659 32 15.823C32 7.164 24.836 0 16 0ZM16 29.177C13.571 29.177 11.264 28.541 9.271 27.423L8.823 27.165L3.782 28.341L4.976 23.447L4.694 22.977C3.471 20.906 2.823 18.518 2.823 16C2.823 8.729 8.729 2.823 16 2.823C23.271 2.823 29.177 8.729 29.177 16C29.177 23.271 23.271 29.177 16 29.177Z"
          fill="white"
        />
        <path
          d="M23.529 19.294C23.153 19.106 21.271 18.188 20.918 18.047C20.565 17.906 20.306 17.835 20.047 18.212C19.788 18.588 19.059 19.459 18.824 19.718C18.588 19.977 18.353 20.012 17.977 19.824C17.6 19.635 16.353 19.224 14.871 17.918C13.718 16.906 12.941 15.647 12.706 15.271C12.471 14.894 12.682 14.671 12.871 14.482C13.047 14.306 13.247 14.035 13.435 13.8C13.624 13.565 13.694 13.4 13.835 13.141C13.976 12.882 13.906 12.647 13.812 12.459C13.718 12.271 12.941 10.388 12.624 9.635C12.318 8.906 12.006 9.012 11.765 9C11.541 8.988 11.282 8.988 11.024 8.988C10.765 8.988 10.341 9.082 9.988 9.459C9.635 9.835 8.659 10.753 8.659 12.635C8.659 14.518 10.024 16.329 10.212 16.588C10.4 16.847 12.941 20.753 16.847 22.447C17.671 22.8 18.318 23.012 18.824 23.165C19.647 23.424 20.4 23.388 21.012 23.294C21.694 23.188 23.224 22.482 23.541 21.694C23.859 20.906 23.859 20.235 23.765 20.082C23.671 19.929 23.412 19.835 23.035 19.647L23.529 19.294Z"
          fill="white"
        />
      </svg>
    </a>
  )
}

export default WhatsAppButton
